export const weekdaysShortcuts = ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"];
export const weekdaysShortcutsFromMonday = ["Pn", "Wt", "Śr", "Cz", "Pt", "So", "Nd"];
export const weekdaysShortcuts = ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"];
export const weekdaysShortcutsFromMonday = ["Pn", "Wt", "Śr", "Cz", "Pt", "So", "Nd"];
